import React from 'react';
import { Link } from 'react-router-dom';

// Import elevation images for featured homes
// Aurora
import auroraElevA from '../../assets/images/Aurora/Yeremian---Aurora-A-cr (1).jpg';
import auroraElevB from '../../assets/images/Aurora/Yeremian-Aurora-B-cr (1).jpg';
import auroraElevC from '../../assets/images/Aurora/Yeremian--Aurora-C-cr (1).jpg';

// Victoria
import victoriaElevA from '../../assets/images/Victoria/Yeremian--Victoria-A-cr.jpg';
import victoriaElevB from '../../assets/images/Victoria/Yeremian--Victoria-B-cr.jpg';
import victoriaElevC from '../../assets/images/Victoria/Yeremian--Victoria-C-cr.jpg';

// Ceres
import ceresElevA from '../../assets/images/Ceres/Yeremian-Ceres-A-cr (1).jpg';
import ceresElevB from '../../assets/images/Ceres/Yeremian--Ceres-B-cr (2).jpg';
import ceresElevC from '../../assets/images/Ceres/Yeremian-Ceres-C-cr (1).jpg';

// Diana
import dianaElevA from '../../assets/images/Diana/Yeremian-Diana-A-cr (1).jpg';
import dianaElevB from '../../assets/images/Diana/Yeremian--Diana-B-cr (1).jpg';
import dianaElevC from '../../assets/images/Diana/Yeremian-Diana-C-cr (1).jpg';

// This would typically come from an API or database
const featuredHomes = [
  {
    id: 'aurora',
    name: 'Aurora',
    description: 'A two-story floor plan with 4 bedrooms and 3.5 bathrooms featuring an open concept main level.',
    elevations: [auroraElevA, auroraElevB, auroraElevC],
    bedrooms: 4,
    bathrooms: 3.5,
    sqft: 2800
  },
  {
    id: 'victoria',
    name: 'Victoria',
    description: 'A spacious two-story layout with 4 bedrooms and 4 bathrooms featuring an open-concept design.',
    elevations: [victoriaElevA, victoriaElevB, victoriaElevC],
    bedrooms: 4,
    bathrooms: 4,
    sqft: 3100
  },
  {
    id: 'ceres',
    name: 'Ceres',
    description: 'A stylish and practical design with versatile spaces including a spacious office and flex room.',
    elevations: [ceresElevA, ceresElevB, ceresElevC],
    bedrooms: 3,
    bathrooms: 2.5,
    sqft: 2500
  },
  {
    id: 'diana',
    name: 'Diana',
    description: 'A beautiful two-story home with a spacious living room, dining room, and four bedrooms.',
    elevations: [dianaElevA, dianaElevB, dianaElevC],
    bedrooms: 4,
    bathrooms: 3,
    sqft: 2700
  }
];

// Function to get elevation based on index (A=0, B=1, C=2, then cycles back)
const getElevationForIndex = (elevations: string[], index: number): string => {
  return elevations[index % 3];
};

const FeaturedHomes: React.FC = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
      {featuredHomes.map((home, index) => (
        <div key={home.id} className="bg-white rounded-lg shadow-md overflow-hidden group hover:shadow-xl transition duration-300">
          <Link to={`/homes/${home.id}`}>
            <div className="relative h-56 overflow-hidden">
              <img 
                src={getElevationForIndex(home.elevations, index)} 
                alt={`${home.name} - Elevation ${String.fromCharCode(65 + (index % 3))}`} 
                className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition duration-300"></div>
              <div className="absolute top-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded">
                Elevation {String.fromCharCode(65 + (index % 3))}
              </div>
            </div>
            <div className="p-6">
              <h3 className="text-xl font-serif text-dark mb-2">{home.name}</h3>
              <div className="flex justify-between text-sm text-gray-600 mb-3">
                <span>{home.bedrooms} Beds</span>
                <span>{home.bathrooms} Baths</span>
                <span>{home.sqft} sqft</span>
              </div>
              <p className="text-gray-600 line-clamp-3">{home.description}</p>
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default FeaturedHomes; 